<script lang="ts">
  import { defineComponent } from 'vue';
  import { getMobileInsetsData } from '@/helpers/utils';
  import { StoreMutations } from '@/helpers/enums';

  export default defineComponent({
    props: {
      showPopup: { type: Boolean, required: true },
      expandable: { type: Boolean, default: false },
    },
    computed: {
      paddingBottom(): number {
        if (this.$store.state.keyboardOpen) {
          return 0;
        }
        return getMobileInsetsData()?.bottom || 0;
      },
    },
    watch: {
      showPopup: {
        handler(shown: boolean) {
          if (shown) {
            this.$store.commit(
              StoreMutations.disableHardwareBackButtonNavigation
            );
          } else {
            this.$store.commit(
              StoreMutations.enableHardwareBackButtonNavigation
            );
          }
        },
      },
    },
    mounted() {
      if (this.showPopup) {
        this.$store.commit(StoreMutations.disableHardwareBackButtonNavigation);
      }
    },
    unmounted() {
      this.$store.commit(StoreMutations.enableHardwareBackButtonNavigation);
    },
  });
</script>

<template>
  <Teleport to="body">
    <div :class="{ active: showPopup }" class="popup">
      <div class="popup--backdrop" />
      <div
        class="popup--wrapper"
        :style="{ paddingBottom: showPopup ? `${paddingBottom}px` : 0 }"
        :class="{ expandable: expandable }"
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
  .popup {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 990;
    height: 0;
    overflow: hidden;
    transition: height 0ms ease-in 300ms;

    &.active {
      transition: height 0ms ease-in 0ms;
      height: 100vh;
    }

    &--backdrop {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($gray-black, 0.2);
      opacity: 0;
      transition: opacity 300ms ease-in;
      z-index: 991;
      overflow: hidden;

      .popup.active & {
        opacity: 1;
      }
    }

    &--wrapper {
      position: absolute;
      left: 0;
      bottom: -100%;
      right: 0;
      z-index: 992;
      height: 0;
      background: $white;
      border-radius: 1.5 * $base-unit 1.5 * $base-unit 0 0;
      overflow: hidden;
      transition:
        bottom 300ms ease-in,
        height 0ms ease-in 300ms;

      .popup.active & {
        transition: bottom 300ms ease-in;
        height: 65vh;
        bottom: 0;
      }

      .popup.active &.expandable {
        transition: bottom 300ms ease-in;
        max-height: 80vh;
        height: auto;
        bottom: 0;
      }
    }
  }
</style>
